// extracted by mini-css-extract-plugin
export default {"marketing-name":"GUOxGdHUXNch5xBfMoFJ","summary":"VomKCA965_tyDCrZPhjI","ai-icon":"I2wuDRK598vJD3Q61vjJ","link-wrapper":"uh5nmeKtkE1uleVKFIMl","link":"aJdfMMvctVzsgXhpViGl"};